export const ADD = 'selectionState/ADD';
export const SET = 'selectionState/SET';
export const GET = 'selectionState/GET';
export const UPDATE = 'selectionState/UPDATE';
export const CLEAR = 'selectionState/CLEAR';
export const SELECTION_STATE = 'selectionState';
export const COURSEWARE_ITEMS = 'coursewareItems';
export const SUB_TARGET = 'subTarget';
export const CLIP = 'clip';
